<div *ngIf="constructor.name.length > 1" class="component-name">>> {{constructor.name}} <<</div>

<div appTheme>
    <div class="modal-box scrolling">

        <div class="modal-box-container main-container" (click)="eatClick($event)">
            <div class="top-columns">
                <img class="company-logo" src="../../../assets/smrtscape_logo.png" alt="">
            </div>
            <div class="row">
                <div class="col-md-12 welcome-page-text">
                    <div class="tag-line">
                        <div class="tag-line">{{ Constants.SmrtScapeTagLine01 }}</div>
                        <div class="tag-line">{{ Constants.SmrtScapeTagLine02 }}</div>
                    </div>
                </div>
            </div>
            <div class="bottom text-center">
                <button class="submit-button button-medium" id="getStartedBtn" type="button" (click)="getStarted()">
                    Get Started <i class="fa fa-arrow-right" aria-hidden="true"></i>
                </button>
                <div class='login'>
                    <a (click)="toggleLogin()" id="signInLink">Sign In</a>
                </div>
                <div class='forgot-password'>
                    <a (click)="toggleForgotPassword()" id="forgotBtn">Forgot Password</a>
                </div>
            </div>
        </div>
    </div>
</div>
<div *ngIf="showLogin" class="modal-box scrolling" (click)="toggleLogin()">
    <app-login></app-login>
</div>
<div *ngIf="showForgotPassword" class="modal-box scrolling" (click)="toggleForgotPassword()">
    <app-forgot-password></app-forgot-password>
</div>
